import https from "./https";
import store from "@/store";

const point = {
  async getRewardsCard(id) {
    const organization = store.state.liffGeneral.orgCode
    let { data } = await https.get(`${organization}/liff/reward-cards/${id}`)
    return data.data
  },

  async listGifts(id, page = 1) {
    const organization = store.state.liffGeneral.orgCode
    let { data } = await https.get(`${organization}/liff/reward-cards/${id}/gifts?page=${page}`)
    return data
  },

  async redeemGift(id, params) {
    const organization = store.state.liffGeneral.orgCode
    let {data} = await https.post(`${organization}/liff/reward-cards/${id}/redeem`, params)
    return data
  },

  async listProductsOfShop(id, branchId) {
    const organization = store.state.liffGeneral.orgCode
    let { data } = await https.get(`${organization}/liff/reward-cards/${id}/branches/${branchId}/products`)
    return data
  },

  async generateAllMissionsTokens(id, params) {
    const organization = store.state.liffGeneral.orgCode
    let { data } = await https.post(`${organization}/liff/reward-cards/${id}/generate-all-missions-tokens`, params)
    return data.data
  },
}

export default point
